import React from "react";
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from "../Tabs/Tabs";
import PropertyDetailsPresenterTabContent from "./PropertyDetailsPresenterTabContent";

class PropertyDetailsPresenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.property.id,
      name: this.props.property.name,
      address_1: this.props.property.address_1,
      address_2: this.props.property.address_2,
      city: this.props.property.city,
      state: this.props.property.state,
      country: this.props.property.country,
      postal_code: this.props.property.postal_code,
      file_upload_group: this.props.property.file_upload_group,
      image_group: this.props.property.image_group,
      link_color: this.props.property.link_color,
      button_background_color: this.props.property.button_background_color,
      button_font_color: this.props.property.button_font_color,
      main_telephone: this.props.property.main_telephone,
      tollfree_telephone: this.props.property.tollfree_telephone,
      mobile_telephone: this.props.property.mobile_telephone,
      fax_telephone: this.props.property.fax_telephone,
      tdd_telephone: this.props.property.tdd_telephone,
      email: this.props.property.email,
      website_url: this.props.property.website_url,
      website_name: this.props.property.website_name,
      active_tab: "general",
      loading: false,
      logo_image_url: this.props.logo_image_url,
      property_details_revision_history_path:
        this.props.property_details_revision_history_path,
      time_format: this.props.time_format,
      date_format: this.props.date_format,
      revert: this.props.revert,
      remotelock_refresh_token: this.props.property.remotelock_refresh_token,
      remotelock_grace_period_in_minutes:
        this.props.property.remotelock_grace_period_in_minutes,
      //Reservation Setting Props
      date: this.props.date,
      date_formats: this.props.date_formats || [],
      time: this.props.time,
      time_formats: this.props.time_formats || [],
      id: this.props.reservation_setting
        ? this.props.reservation_setting.id
        : null,
      check_in_time: this.props.reservation_setting
        ? new Date(this.props.reservation_setting.check_in_time)
        : null,
      check_out_time: this.props.reservation_setting
        ? new Date(this.props.reservation_setting.check_out_time)
        : null,
      maximum_stay: this.props.reservation_setting
        ? this.props.reservation_setting.maximum_stay
        : null,
      date_format: this.props.reservation_setting
        ? this.props.reservation_setting.date_format
        : null,
      time_format: this.props.reservation_setting
        ? this.props.reservation_setting.time_format
        : null,
      auto_assign: this.props.reservation_setting
        ? this.props.reservation_setting.auto_assign
        : null,
        default_check_in_date: this.props.reservation_setting
        ? this.props.reservation_setting.default_check_in_date
        : null,
        default_number_of_nights: this.props.reservation_setting
        ? this.props.reservation_setting.default_number_of_nights
        : null,
        booking_window_days: this.props.reservation_setting
        ? this.props.reservation_setting.booking_window_days
        : null,
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this);
  }

  componentDidMount() {
    var self = this;

    $(window).on("propertyDetailsSaved", function () {
      $.ajax({
        type: "POST",
        url: "/admin/property-details/data",
      }).done((data) => {
        $(".logo_image")[0].src = data.logo_image_url;
        self.setState({
          name: data.property.name,
          address_1: data.property.address_1,
          address_2: data.property.address_2,
          city: data.property.city,
          state: data.property.state,
          country: data.property.country,
          postal_code: data.property.postal_code,
          logo_image_url: data.logo_image_url,
          file_upload_group: data.property.file_upload_group,
        });
      });
    });
  }

  render() {
    var self = this;
    if(this.props.historical_view == true) {
      var buttons = [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("revert"),
          button_classes: ["primary"],
          onClick: function (e) {
            self.onChangeRevertVersion();
            return false;
          },
        },
      ];
    } else  {
      var buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        }
      ]

    }
    return (
      <div className="property-details-presenter">
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <Tabs tabs={this.tabs()} />
          <PropertyDetailsPresenterTabContent
            {...this.props}
            {...this.state}
            onChangeActiveTab={this.onChangeActiveTab}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  onChangeActiveTab(active_tab) {
    this.setState({
      active_tab: active_tab,
    });
  }

  tabs() {
    if (
      this.props.superadmin &&
      this.props.property &&
      this.props.property.id
    ) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("payment_gateway"),
          targetName: "payment_gateway",
          classes:
            this.state.active_tab === "payment_gateway" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("invite_administrator"),
          targetName: "invite_administrator",
          classes:
            this.state.active_tab === "invite_administrator" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ];
    } else {
      if(this.props.historical_view == true) {
        return [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ];
      } else {
        return [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("reservation_settings"),
            targetName: "reservation_settings",
            classes:
              this.state.active_tab === "reservation_settings" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("locks"),
          targetName: "locks",
          classes: this.state.active_tab === "locks" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("history"),
            targetName: "history",
            classes: this.state.active_tab === "history" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
       
        ];

      }   
    }
  }

  onChangeRevertVersion() {
    $.ajax({
      type: "POST",
      url: `/admin/property-details/${this.state.id}/version/${this.props.vid}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger("propertyDetailsSaved");

      this.setState({ loading: false });
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t("property_details_updated_successfully"));
      }

      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    });
  }
}

export default PropertyDetailsPresenter;
